import type { ServerMessage } from './messages';

export function isServerMessage(value: unknown): value is ServerMessage {
  if (!isRecord(value)) return false;
  if (typeof value.type !== 'string' || typeof value.seq !== 'number' || typeof value.time !== 'number') return false;
  if (!isRecord(value.payload)) return false;

  switch (value.type) {
    case 'server.ready':
      return Array.isArray(value.payload.universe) && Array.isArray(value.payload.indexes);
    case 'server.status':
      return typeof value.payload.connected === 'boolean' && typeof value.payload.message === 'string';
    case 'server.quoteSnapshot':
      return typeof value.payload.requestId === 'string' && Array.isArray(value.payload.quotes);
    case 'server.quoteDeltaBatch':
      return Array.isArray(value.payload.updates);
    case 'server.barSnapshot':
      return typeof value.payload.requestId === 'string' && typeof value.payload.symbol === 'string' && Array.isArray(value.payload.bars);
    case 'server.barUpdate':
      return typeof value.payload.requestId === 'string' && isRecord(value.payload.bar);
    case 'server.newsSnapshot':
      return typeof value.payload.requestId === 'string' && Array.isArray(value.payload.items);
    case 'server.newsUpdate':
      return isRecord(value.payload.item);
    case 'server.pong':
      return typeof value.payload.clientTime === 'number';
    case 'server.error':
      return typeof value.payload.code === 'string' && typeof value.payload.message === 'string';
    default:
      return false;
  }
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}
